<template>
  <main class="marketing-email-edit-send">
    <loading v-if="loading" />

    <app-form v-else
              @submit="send">
      <marketing-form-send v-if="item"
                           v-model="sendSchedule"
                           :initial-data="item"
                           :view-only="viewOnly" />

      <div class="marketing-email-edit-send-actions">
        <button v-if="!viewOnly"
                class="btn btn-outline btn-extra-round"
                type="button"
                @click="saveContent">
          {{$t('message.marketingGenerics.message.saveDraft')}}
        </button>

        <button class="btn btn-primary btn-extra-round"
                type="submit">
            {{$t('message.generics.message.advance')}}
        </button>
      </div>
    </app-form>
  </main>
</template>

<script>
import EventBus from "@packages/event-bus";
import Loading from "@/components/generic/Loading.vue";
import MarketingFormSend from "@components/modules/marketing/generic/form/send/MarketingFormSend";
import AppForm from "@components/form/Form.vue";

export default {
  components: {
    AppForm,
    MarketingFormSend,
    Loading,
  },

  data() {
    return {
      item: undefined,
      isAutomationFlow: false,
      sendSchedule: {
        schedule: {
          date: undefined,
          hour: undefined,
        },
        scheduleType: undefined,
      },
      loading: false,
    };
  },

  created() {
    this.fetchEmail();
  },

  computed: {
    viewOnly() {
      return this.$store.state.marketing.email.edit.viewOnly;
    },
  },

  mixins: [],

  methods: {
    async fetchEmail() {
      this.loading = true;

      const emailId = this.$route.params.emailId;

      const email = await this.$api.marketing.email.message.get({
        emailId,
      });

      this.isAutomationFlow = email.isAutomationFlow;
      this.$store.commit("EMAIL_EDIT_SET_AUTOMATION", email.isAutomationFlow);

      this.item = email;

      if (email.schedulerDate) {
        const splitSchedule = email.schedulerDate.split(" ");

        this.sendSchedule = {
          scheduleType: "SCHEDULE",
          schedule: {
            date: splitSchedule[0],
            hour: splitSchedule[1],
          },
        };
      }

      this.loading = false;
    },
    async send() {
      if (!this.viewOnly) {
        await this.$api.marketing.email.send.send({
          emailId: this.item.id,
          schedulerDate: this.getFormatedSchedulerDate(),
        });
      }

      this.$router.push({
        path: "/marketing/email",
      });
    },
    async saveContent() {
      await this.$api.marketing.email.message.edit({
        emailId: this.item.id,
        data: {
          ...this.item,
          schedulerDate: this.getFormatedSchedulerDate(),
        },
      });

      this.$router.push({
        path: "/marketing/email",
      });

      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: this.$t('message.successMessages.message.draftSaved'),
      });
    },
    getFormatedSchedulerDate() {
      let schedulerDate;

      if (this.sendSchedule.scheduleType === "SCHEDULE") {
        schedulerDate = `${this.sendSchedule.schedule.date} ${this.sendSchedule.schedule.hour}:00`;
      }

      return schedulerDate;
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-edit-send {
  .marketing-email-edit-send-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    padding: 50px 0;
  }
}
</style>
